// NavigationContext.js - A context to keep track of navigation history
import React, { createContext, useContext, useState } from 'react';

const defaultValue = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  pushToHistory: (location) => {},
  popHistory: () => {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  getPreviousLocation: (e=[]) => '/',
  history: [],
};

export const NavigationHistoryContext = createContext(defaultValue);

export function NavigationHistoryProvider({ children }) {
  const [history, setHistory] = useState([]);

  const pushToHistory = (location) => {
    setHistory((prevHistory) => [...prevHistory, location]);
  };

  const popHistory = () => {
    setHistory((prevHistory) => prevHistory.slice(0, -1));
  };

  const getPreviousLocation = (excluding=[]) => {
    // Do not return any of the locations in the excluding array
    for (let i = history.length - 1; i >= 0; i--) {
      if (!excluding.includes(history[i])) {
        return history[i];
      }
    }
    return undefined;
  };

  return (
    <NavigationHistoryContext.Provider value={{ 
      pushToHistory, 
      popHistory, 
      getPreviousLocation,
      history,
    }}>
      {children}
    </NavigationHistoryContext.Provider>
  );
}

export function useNavigationHistory() {
  return useContext(NavigationHistoryContext);
}
